'use client';
import React, { CSSProperties } from 'react';
import classes from './style.module.scss';
import ButtonWithIcon from '@/components/shared/Button/button-with-icon/button-with-icon.component';
import Typography from '@/components/shared/typography/typography.component';
import { ArrowDownWhiteWithTail } from '../../../../../../public/Images';
import { useTranslation } from '@/hook';

const CarUnpublishedOverlay = ({ style }: { style?: CSSProperties }) => {
    const { t } = useTranslation();

    const scrollOptions: ScrollToOptions = {
        left: 0,
        top: 250,
        behavior: 'smooth',
    };
    const handleScroll = () => {
        window.scrollTo(scrollOptions);
    };
    return (
        <div className={classes.container} style={style}>
            <div className={classes.blurOverlay2} />
            <div className={classes.blurOverlay}>
                <div className={classes.contentContainer}>
                    <Typography variant="subtitle1SemiBold" color={'#00673E'}>
                        {t('unpublishedPage.title')}
                    </Typography>
                    <Typography variant="body2">
                        {t('unpublishedPage.description')}
                    </Typography>
                    <ButtonWithIcon
                        text={t('soldPage.CTA')}
                        img={ArrowDownWhiteWithTail}
                        //Why do we have same icon ? please fix this.
                        imgActive={ArrowDownWhiteWithTail}
                        buttonClicked={handleScroll}
                        active
                        style={{
                            display: 'flex',
                            flexDirection: 'row-reverse',
                        }}
                        extraClassNames={' mt-2 '}
                        innerExtraClassNames={''}
                    />
                </div>
            </div>
        </div>
    );
};

export default CarUnpublishedOverlay;
